import styled from 'styled-components'

const StyledPaymentModal = styled.div`
  width: 100vw;
  max-width: 500px;
  padding: 32px;

  h1 {
    margin: 0 0 1rem 0;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.gray[800]};
  }

  form {
    display: flex;
    flex-direction: column;
  }

  .btn {
    margin-top: 32px;
    align-self: center;
  }
`

export default StyledPaymentModal
